import {
  BubbleMenuPluginProps,
  BubbleMenuView,
  BubbleMenuViewProps,
} from '@tiptap/extension-bubble-menu';
import { EditorView } from '@tiptap/pm/view';
import { EditorState, Plugin, PluginKey } from '@tiptap/pm/state';

export class StBubbleMenuView extends BubbleMenuView {
  public mouseDown: boolean = false;
  public shown: boolean = false;

  constructor(props: BubbleMenuViewProps) {
    super(props);
    document.addEventListener('mouseup', this.onMouseUp);
    this.view.dom.addEventListener('mousedown', this.onMousedownHandler);
  }

  onMouseUp = () => {
    if (!this.mouseDown) return;
    this.mouseDown = false;
    requestAnimationFrame(() => {
      this.update(this.editor.view);
    });
  };

  onMousedownHandler = () => {
    this.mouseDown = true;
    if (this.shown) {
      this.hide();
    }
  };

  update(view: EditorView, oldState?: EditorState) {
    // on mousedown flag just return to prevent the menu from showing
    // we will fire the update manually after the mouseup event
    if (this.mouseDown) return;
    super.update(view, oldState);
  }

  show(): void {
    super.show();
    this.shown = true;
  }

  hide(): void {
    super.hide();
    this.shown = false;
  }

  destroy() {
    document.removeEventListener('mouseup', this.onMouseUp);
    this.view.dom.removeEventListener('mousedown', this.onMousedownHandler);
    super.destroy();
  }
}

export const StBubbleMenuPlugin = (options: BubbleMenuPluginProps) => {
  return new Plugin({
    key:
      typeof options.pluginKey === 'string' ? new PluginKey(options.pluginKey) : options.pluginKey,
    view: (view) => new StBubbleMenuView({ view, ...options }),
  });
};
